import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  state: {
    myInfo: {
      name: '',
      credentialType: '',
      credentialNumber: '',
      expirationDate: '',
      birthDate: '',
      memberInfo: {
        score: 0,
        level: 0,
        level_plus: 0,
        nextLevelPrice: 0,
        showNextLevelPrice: false
      },
      coupons: [
        {
          title: '',
          limit: '',
          expirationDate: '',
          discount: ''
        }
      ],
      session: {
        time: '',
        title: '',
        address: '',
        seats: []
      },
      orders: [{
        orderId: '',
        total: '',
        status: '',
        orderInfo: [
          {
            pic: '',
            title: '',
            time: '',
            seats: [],
            price: ''
          }
        ]
      }],
    },
    currentCoupon: {
      couponId: '',
      name: '',
      expiredDate: '',
      description: '',
    },
    faq: [{
      question: '',
      answer: '',
    }],
    userName: '',
    refund: {
      refund_account: '',
      tickets: [{
        bcd_id: '',
        program_name: '',
        play_date: '',
        start_time: '',
        vasc_name: '',
        vasr_name: '',
        check_status: ''
      }]
    },
    voucher: {
      submit_account: ''
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/my/index.js